import { AHIcon, AHText, AHTextFonts } from "arkh";

import { Item } from "./Item";
import React from "react";
import { View } from "react-native";

export const UserItem = ({
  onPress,
  selected,
  name,
  ref,
}: {
  onPress?: () => void;
  selected?: boolean;
  name: string;
  ref?: React.RefObject<View | null>;
}) => {
  return (
    <Item
      onPress={onPress}
      color={selected ? "text-primary" : "surface-primary"}
      borderColor={selected ? "text-primary" : "border-primary"}
    >
      <AHText
        font={AHTextFonts.BOLD}
        color={selected ? "text-inverted" : "text-primary"}
        numberOfLines={1}
        style={{ flex: 1 }}
        spaceHorizontal="small"
      >
        {name}
      </AHText>
      {selected && onPress ? (
        <View ref={ref}>
          <AHIcon type="more" color="surface" size="medium" />
        </View>
      ) : null}
    </Item>
  );
};
